import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CurrencyConvertService } from "../services/currency-convert.service";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";

@Component({
  selector: "app-dynamic-currency",
  templateUrl: "./dynamic-currency.component.html",
  styleUrls: ["./dynamic-currency.component.scss"],
})
export class DynamicCurrencyComponent implements OnInit {
  @Input() public invalid: string;
  @Input() public myLabel = "";
  @Input() public fieldId = "";
  @Input() public type;
  @Output() currencyToEmit = new EventEmitter<object>();
  @Input() public set currencyValue(val) {
    if (val && typeof val === 'string' && val.indexOf('-') > 0) {
      const split = val.split('-');
      // @ts-ignore
      this.selectedCurrency = this.currencyCodes.find(currency => currency.code ? currency.code === split[0] : false);
      this.selectedValue = Number.parseFloat(split[1]);
      this.currencyValueToSend = val;
    } else {
      this.selectedValue = Number.parseFloat(val);
    }
  }

  public currencyValueToSend;
  public selectedCurrencyCode = "GBP";
  public currencyCodes = this.currencyService._currencyList;
  public selectedCurrency: any = this.currencyCodes[0];
  public selectedValue;

  constructor(
    private sideNavBarVisibilityService: SideNavBarVisibilityService,
    private currencyService: CurrencyConvertService
  ) { }

  ngOnInit(): void {
  }

  selectedCurrencyValue() {
    this.currencyValueToSend = this.selectedCurrency.code + '-' + this.selectedValue;
    this.currencyToEmit.emit({ currencyValueToSend: this.currencyValueToSend, fieldId: this.fieldId })
  }
}
